import React, { Component } from 'react';
import { Nav, Navbar } from 'react-bootstrap';

import Profile from './Profile.js';
import SettingsPopup from './SettingsPopup.js';

import './TopBar.css';

class TopBar extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mapLoaded: false,
            categoryTitle: 'Categories',
            assetsTitle: 'Assets',
            musterTitle: 'Muster Point'
        };

        this.settingsPopup = React.createRef();
    }

    handleOpenSettings = () => {
        if (this.settingsPopup.current)
        {
            this.settingsPopup.current.show();
        }
    }

    //settings drive the nav labels (CategoryString etc.), so re-pull them after any save
    handleSettingSaved = () => {
        this.reloadCategoryString();
        this.reloadAssetString();
        this.reloadMusterPointString();
    }

    componentDidMount() {
        this.reloadCategoryString();
        this.reloadAssetString();
        this.reloadMusterPointString();
    }

    reloadCategoryString = () => {
        fetch('get_category_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && data[0].value) {
                this.setState({ categoryTitle: data[0].value });
            }
        })
        .catch(console.log)
    }

    reloadAssetString = () => {
        fetch('get_asset_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && data[0].value) {
                this.setState({ assetsTitle: data[0].value });
            }
        })
        .catch(console.log)
    }

    reloadMusterPointString = () => {
        fetch('get_muster_point_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && data[0].value) {
                this.setState({ musterTitle: data[0].value });
            }
        })
        .catch(console.log)
    }

    isLoggedOut = (username, accessLevel) => {
        this.props.isLoggedOut(username, accessLevel);
    }

    handleOpenProfile = () => {
        this.props.showProfile();
    }

    showMapButton = () => {
        this.setState({
            mapLoaded: true
        });
    }

    renderMapButton = () => {

        if (this.state.mapLoaded)
        {
            return (
                <Nav.Link className="mapLinkOn" onClick={ this.props.showMap }>Map</Nav.Link>
            )
        }
        else
        {
            return (
                <Nav.Link className="mapLinkOff">Map</Nav.Link>
            )
        }
    }

    render() {
        if (1 === this.props.accessLevel)
        {
            return (<Navbar className="sensorpack-nav" bg="light" expand="lg">
                <Navbar.Brand href="#home"><img src="LogoLight.png" alt="AutoMap Logo" width="200px"></img></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav.Link onClick={ this.props.showRecordings } >Recordings</Nav.Link>
                    <Nav.Link onClick={ this.props.showAtlas } >Atlas</Nav.Link>
                    <Nav.Link onClick={ this.props.showPipeline } >Pipeline</Nav.Link>
                    <Nav.Link onClick={ this.props.showProcess } >Process</Nav.Link>
                    <Nav.Link onClick={ this.props.showWorkflows } >Workflows</Nav.Link>
                    <Nav.Link onClick={ this.props.showAssets } >{this.state.assetsTitle}</Nav.Link>
                    <Nav.Link onClick={ this.props.showCategories } >{this.state.categoryTitle}</Nav.Link>
                    <Nav.Link onClick={ this.props.showMusterPoints } >{this.state.musterTitle}</Nav.Link>
                    <Nav.Link onClick={ this.props.showHistory } >History</Nav.Link>
                    <Nav.Link onClick={ this.props.showUsers }>Users</Nav.Link>
                    <Nav.Link onClick={ this.props.showSensorpackSettings }>Scanner Settings</Nav.Link>
                    { this.renderMapButton() }
                </Navbar.Collapse>
                <Profile handleOpenProfile={this.handleOpenProfile} isLoggedOut={this.isLoggedOut} username={this.props.username} accessLevel={this.props.accessLevel} showSettings={this.handleOpenSettings} />
                <SettingsPopup ref={this.settingsPopup} onSaved={this.handleSettingSaved} />
                </Navbar>);
        }
        else
        {
            return (<Navbar bg="light" expand="lg">
                <Navbar.Brand href="#home"><img src="LogoLight.png" alt="AutoMap Logo" width="200px"></img></Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav.Link onClick={ this.props.showRecordings } >Recordings</Nav.Link>
                    <Nav.Link onClick={ this.props.showAtlas } >Atlas</Nav.Link>
                    <Nav.Link onClick={ this.props.showProfile } >Pipeline</Nav.Link>
                    <Nav.Link onClick={ this.props.showProcess } >Process</Nav.Link>
                    <Nav.Link onClick={ this.props.showWorkflows } >Workflows</Nav.Link>
                    <Nav.Link onClick={ this.props.showCategories } >{this.state.categoryTitle}</Nav.Link>
                    <Nav.Link onClick={ this.props.showHistory } >History</Nav.Link>
                </Navbar.Collapse>
                <Profile handleOpenProfile={this.handleOpenProfile} isLoggedOut={this.isLoggedOut} username={this.props.username} />
                </Navbar>);
        }
    }
}

export default TopBar;
